// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__tZVnZ","fade-in":"loading_fade-in__9hDxh","closed":"loading_closed__2Wufe","fade-out":"loading_fade-out__LjNg0"};